import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import Loader from "../../../components/Loader";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import { Segmented, Tooltip } from "antd";
import HPPJobs from "../../../components/candidate/jobs/HPPJobs";
import { ROLES } from "../../../constants/UserRoles";

const options = [
  { label: "HirePlusPlus", value: "Hireplusplus" },
  {
    label: (
      <Tooltip title="Coming Soon" placement="top">
        <span className="flex items-center justify-center gap-1.5 text-gray-400 cursor-not-allowed select-none w-full h-full pointer-events-auto">
          Others
        </span>
      </Tooltip>
    ),
    value: "Others",
    disabled: true,
  },
];

const userDetail = Utils.getUserDetail();
function Jobs() {
  const [selected, setSelected] = useState("Hireplusplus");

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="jobs" userRole={ROLES.b2b_candidate} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="jobs"
            userRole={ROLES.b2b_candidate}
            newTitle="Jobs"
            noNavigate={true}
          />
          {/* {moduleInfo?.hasJobAccessGranted && <div>jobs data</div>}
          {moduleInfo?.hasJobAccessGranted === false && (
            <RequestAccess moduleName="JOBS" />
          )} */}
          <div className="w-full px-5 pt-3 pb-4">
            <Segmented
              block
              className="w-full max-w-[350px] jobs-segmented"
              options={options}
              size="large"
            />
            <div className="mt-4">
              {selected === "Hireplusplus" && <HPPJobs />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Jobs;
